<template>
  <div class="">
    <bank-accounts> </bank-accounts>
  </div>
</template>

<script>
import BankAccounts from "@/components/profile/bank-accounts/index.vue";

import { mapActions } from "vuex";

export default {
  props: {
    msg: String,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    BankAccounts,
  },
  created() {
    this.notifyQueue({
      text: "Banche",
      path: "bank_accounts.index",
      level: 1,
    });
  },
};
</script>
